import React, { useEffect, useState } from 'react';

const THEMES = {
  1: {                          // CTG Global School — blue/red error
    overlay:    'rgba(7,16,31,0.6)',
    cardBg:     '#ffffff',
    headerBg:   'linear-gradient(135deg,#fff1f2 0%,#ffe4e6 100%)',
    headerBorder:'#fecdd3',
    accent:     '#ef4444',
    accentDim:  'rgba(239,68,68,0.1)',
    iconBg:     '#fff1f2',
    iconColor:  '#dc2626',
    titleColor: '#7f1d1d',
    textColor:  '#374151',
    itemBorder: '#fee2e2',
    itemBg:     '#fff8f8',
    itemAccent: '#ef4444',
    valBorder:  '#bfdbfe',
    valBg:      '#f8fafc',
    valAccent:  '#3b82f6',
    valText:    '#1e3a6e',
    btnBg:      '#ef4444',
    btnHov:     '#dc2626',
    footerText: '#6b7280',
  },
  2: {                          // CTG Vidya Mandir — purple/red error
    overlay:    'rgba(18,8,42,0.65)',
    cardBg:     '#ffffff',
    headerBg:   'linear-gradient(135deg,#fff1f2 0%,#ffe4e6 100%)',
    headerBorder:'#fecdd3',
    accent:     '#ef4444',
    accentDim:  'rgba(239,68,68,0.1)',
    iconBg:     '#fff1f2',
    iconColor:  '#dc2626',
    titleColor: '#7f1d1d',
    textColor:  '#374151',
    itemBorder: '#fee2e2',
    itemBg:     '#fff8f8',
    itemAccent: '#ef4444',
    valBorder:  '#ddd6fe',
    valBg:      '#faf9ff',
    valAccent:  '#7c3aed',
    valText:    '#3b0764',
    btnBg:      '#ef4444',
    btnHov:     '#dc2626',
    footerText: '#6b7280',
  },
  default: {
    overlay:    'rgba(0,0,0,0.5)',
    cardBg:     '#ffffff',
    headerBg:   'linear-gradient(135deg,#fff1f2 0%,#ffe4e6 100%)',
    headerBorder:'#fecdd3',
    accent:     '#ef4444',
    accentDim:  'rgba(239,68,68,0.1)',
    iconBg:     '#fff1f2',
    iconColor:  '#dc2626',
    titleColor: '#7f1d1d',
    textColor:  '#374151',
    itemBorder: '#fee2e2',
    itemBg:     '#fff8f8',
    itemAccent: '#ef4444',
    valBorder:  '#dcfce7',
    valBg:      '#f9fffe',
    valAccent:  '#16a34a',
    valText:    '#14532d',
    btnBg:      '#ef4444',
    btnHov:     '#dc2626',
    footerText: '#6b7280',
  },
};

const NotifyError = ({ isHide, handleCloseErrorModal, title, message, Errors, themeId }) => {
  const t = THEMES[themeId] || THEMES.default;
  const [hov, setHov] = useState(false);
  const [visible, setVisible] = useState(false);

  const show = !isHide;

  useEffect(() => {
    if (show) setTimeout(() => setVisible(true), 10);
    else setVisible(false);
  }, [show]);
  
  // With:
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => setVisible(true), 10);
      return () => clearTimeout(timer); // ✅ cleanup
    } else {
      setVisible(false);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div style={{
      position:'fixed', inset:0, zIndex:9999,
      background: t.overlay,
      display:'flex', alignItems:'center', justifyContent:'center',
      padding:'1rem',
      opacity: visible ? 1 : 0,
      transition:'opacity 0.25s ease',
    }}>
      <div style={{
        background: t.cardBg,
        borderRadius:20,
        width:'100%', maxWidth:480,
        boxShadow:'0 24px 60px rgba(0,0,0,0.18)',
        overflow:'hidden',
        maxHeight:'90vh', display:'flex', flexDirection:'column',
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.97)',
        transition:'transform 0.3s cubic-bezier(0.34,1.56,0.64,1)',
      }}>

        {/* Header */}
        <div style={{
          background: t.headerBg,
          borderBottom:`1px solid ${t.headerBorder}`,
          padding:'24px 24px 20px',
          textAlign:'center',
          flexShrink:0,
        }}>
          {/* Error icon */}
          <div style={{
            width:56, height:56, borderRadius:'50%',
            background: t.iconBg,
            border:`2px solid ${t.accent}`,
            display:'flex', alignItems:'center', justifyContent:'center',
            margin:'0 auto 14px',
            boxShadow:`0 0 0 6px ${t.accentDim}`,
          }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
              stroke={t.iconColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h2 style={{
            margin:0, fontSize:18, fontWeight:700,
            color: t.titleColor,
            fontFamily:"'DM Sans','Segoe UI',sans-serif",
            letterSpacing:'-0.01em',
          }}>{title}</h2>
        </div>

        {/* Body */}
        <div style={{ padding:'20px 24px', overflowY:'auto', flex:1 }}>

          {/* Main error message */}
          {message && (
            <div style={{
              display:'flex', alignItems:'flex-start', gap:10,
              padding:'12px 14px',
              background: t.itemBg,
              border:`1px solid ${t.itemBorder}`,
              borderRadius:10,
              marginBottom: Errors && Errors.length ? 14 : 0,
            }}>
              <span style={{
                width:6, height:6, borderRadius:'50%',
                background: t.itemAccent,
                flexShrink:0, marginTop:8,
              }} />
              <p style={{
                margin:0, fontSize:14, color: t.textColor,
                lineHeight:1.6,
                fontFamily:"'DM Sans','Segoe UI',sans-serif",
              }}>{message}</p>
            </div>
          )}

          {/* Validation errors list */}
          {Errors && Errors.length > 0 && (
            <>
              <p style={{
                fontSize:11, fontWeight:600, letterSpacing:'0.08em',
                textTransform:'uppercase', color: t.valAccent,
                margin:'0 0 8px',
                fontFamily:"'DM Sans','Segoe UI',sans-serif",
              }}>Validation Details</p>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {Errors.map((err, i) => (
                  <div key={i} style={{
                    display:'flex', alignItems:'flex-start', gap:10,
                    padding:'10px 14px',
                    background: t.valBg,
                    border:`1px solid ${t.valBorder}`,
                    borderRadius:10,
                  }}>
                    <span style={{
                      width:18, height:18, borderRadius:'50%',
                      background: t.valAccent+'18',
                      border:`1px solid ${t.valAccent}40`,
                      color: t.valAccent,
                      fontSize:10, fontWeight:700,
                      display:'flex', alignItems:'center', justifyContent:'center',
                      flexShrink:0, marginTop:1,
                    }}>{i+1}</span>
                    <p style={{
                      margin:0, fontSize:13, color: t.valText,
                      lineHeight:1.55,
                      fontFamily:"'DM Sans','Segoe UI',sans-serif",
                    }}>
                      {typeof err === 'string' ? err : err.message || err.Message || JSON.stringify(err)}
                    </p>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding:'0 24px 22px',
          flexShrink:0,
        }}>
          <button
            onMouseEnter={() => setHov(true)}
            onMouseLeave={() => setHov(false)}
            onClick={handleCloseErrorModal}
            style={{
              padding:'10px 40px', borderRadius:10, border:'none',
              background: hov ? t.btnHov : t.btnBg,
              color:'#fff', fontWeight:600, fontSize:14,
              cursor:'pointer', letterSpacing:'0.04em',
              transition:'background 0.18s',
              fontFamily:"'DM Sans','Segoe UI',sans-serif",
              width:'100%',
            }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotifyError;